<div class="d-flex flex-column justify-content-between">
  <div>
    <form>
      <div class="form-group">
        <label
          style="
            font-size: 1.1em;
            color: rgb(34, 34, 34);
            font-variant: all-small-caps;
            padding-bottom: 5px;
            font-weight: 600;
          "
          >To</label
        >
        <input
          class="form-control"
          name="to"
          placeholder="edifice@edificegroup.com"
          required
          [(ngModel)]="email.to"
          type="text"
        />
      </div>
      <div class="form-group">
        <label
          style="
            font-size: 1.1em;
            color: rgb(34, 34, 34);
            font-variant: all-small-caps;
            padding-bottom: 5px;
            font-weight: 600;
          "
          >CC (if multiple, seperate by a comma)</label
        >
        <input
          class="form-control"
          name="cc"
          placeholder="edifice@edificegroup.com, automotive@edificegroup.com"
          required
          [(ngModel)]="email.cc"
          type="text"
        />
      </div>
      <div class="form-group">
        <label
          style="
            font-size: 1.1em;
            color: rgb(34, 34, 34);
            font-variant: all-small-caps;
            padding-bottom: 5px;
            font-weight: 600;
          "
          >Subject</label
        >
        <input
          class="form-control"
          name="subject"
          placeholder="Enter email subject"
          required
          [(ngModel)]="email.subject"
          type="text"
        />
      </div>
      <div class="form-group">
        <label
          style="
            font-size: 1.1em;
            color: rgb(34, 34, 34);
            font-variant: all-small-caps;
            padding-bottom: 5px;
            font-weight: 600;
          "
          >Body</label
        >
        <textarea
          class="form-control"
          style="height: 250px"
          name="email_body"
          placeholder="Enter message to be sent with email"
          required
          [(ngModel)]="email.body"
          type="text"
        ></textarea>
      </div>
    </form>
    <p>
      * All files associated with this month's Co-Op will be attached to this
      email in a zip file. Please review before sending.
    </p>
  </div>
  <button class="btn btn-primary pull-right" (click)="sendEmail()">
    <div
      *ngIf="sendingEmail"
      class="spinner-border text-white mr-1"
      style="height: 15px; width: 15px"
      role="status"
    ></div>
    Send Email
  </button>
</div>
